import AuthProvider from './auth.provider'
import CustomerTypeProvider from './customerType.provider'
import EmailProvider from './email.provider'
import LineOfficialAccountProvider from './lineOfficialAccount.provider'
import OrderProvider from './order.provider'
import ProductProvider from './product.provider'
import UserProvider from './user.provider'
import PaymentProvider from './payment.provider'
import FeedbackProvider from './feedback.provider'
import SystemConfigProvider from './systemConfig.provider'
import TaxAgentProvider from './taxAgent.provider'
import FileProvider from './file.provider'

export const AuthService = new AuthProvider()
export const CustomerTypeService = new CustomerTypeProvider()
export const EmailService = new EmailProvider()
export const LineOfficialAccountService = new LineOfficialAccountProvider()
export const OrderService = new OrderProvider()
export const ProductService = new ProductProvider()
export const UserService = new UserProvider()
export const PaymentService = new PaymentProvider()
export const FeedbackService = new FeedbackProvider()
export const SystemConfigService = new SystemConfigProvider()
export const TaxAgentService = new TaxAgentProvider()
export const FileService = new FileProvider()
